import { helper } from '@ember/component/helper';

import { formatDateFormField } from '../utils/format-date-form-field';

function formatDateField([value, locale]) {
  return formatDateFormField(value, locale);
}

export default helper(formatDateField);
